import { Form, Select } from 'antd'
import { useMemo } from 'react'

export default function PatientSearch({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item label="ID do Paciente" name={[fieldName, 'action', 'data', 'paciente_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="CPF do Paciente" name={[fieldName, 'action', 'data', 'paciente_cpf']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
    </>
  )
}
